import api from '../lib/api'
import initialState from '../state'

export const SET_PROJECT = 'export-tool/projects/set-project'
export const FETCH_PROJECTS = 'export-tool/projects/fetch-projects'
export const RECEIVE_PROJECTS = 'export-tool/projects/receive-projects'

export default function reducer(state = {...initialState.projects}, action = {}) {
  const newState = {...state}
  switch (action.type) {
    case SET_PROJECT:
      newState.selected = action.payload.project
      return newState
      break

    case FETCH_PROJECTS:
      newState.fetched = false
      newState.fetching = true
      return newState
      break

    case RECEIVE_PROJECTS:
      newState.fetched = true
      newState.fetching = false
      newState.list = action.payload.projects
      return newState
      break

    default:
      return state
      break
  }
}

export function setProject(project) {
  return {
    type: SET_PROJECT,
    payload: {
      project
    }
  }
}

export function fetchProjects(token) {
  return (dispatch, getState) => {
    const me = getState().me
    const projectId = (typeof me.project === 'object' && me.project !== null) ? me.project.id : me.project
    let canSeeAll = ((me.accessLevel || -1) >= 99)

    if (canSeeAll === false && me.role === 'superuser') {
      canSeeAll = true
    }

    dispatch({ type: FETCH_PROJECTS, payload: null })
    return api
    .projects(token)
    .then(p => {
      let projects = []
      if (canSeeAll === true) {
        projects = [...p]
      } else {
        projects = [...p].filter(p => (p.id === projectId))
      }

      dispatch(receiveProjects(projects))
    })
    .catch(err => {
      console.error(`[fetchProjects] error fetching projects: ${err.message}`)
      dispatch(receiveProjects([]))
    })
  }
}

export function receiveProjects(projects) {
  return {
    type: RECEIVE_PROJECTS,
    payload: {
      projects
    }
  }
}



// WEBPACK FOOTER //
// ./ducks/projects.js